import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import router from './router'; // 引入路由
import store from './store'; // 引入 Vuex store
import 'element-ui/lib/theme-chalk/index.css';
import ApiService from './utils/apiService';
import GlobalServices from './plugins/global-services';
import ConfigPlugin from './plugins/config'; // 引入配置插件
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);
Vue.use(GlobalServices); // 使用全局插件
Vue.use(ConfigPlugin); // 使用配置插件
Vue.use(VueClipboard);

ApiService.setRouter(store);

   // 在 Vue 实例创建之前加载用户信息
store.dispatch('fetchUserInfo').then(() => {
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  });
